import {
  ParamsCreateMarker,
  ResponseCreateMarker,
} from '../models/manager-leaflet.model';
import * as L from 'leaflet';
import { addHoverScaleToMarker } from './add-hover-scale-to-marker.helper';
import { isFirefox } from './is-browser-firefox.helper';

const DEFAULT_ICON = L.icon({
  iconUrl: 'assets/icons/frame.svg',
  iconSize: [32, 32],
  iconAnchor: [16, 16],
  popupAnchor: [0, -16],
});

export function createMarkerWithIcon(
  params: ParamsCreateMarker
): ResponseCreateMarker {
  try {
    const error = managerValidations(params);
    if (error) {
      return {
        marker: L.marker([0, 0]),
        error,
      };
    }

    const marker = L.marker(
      [params.coordinates.latitude, params.coordinates.longitude],
      {
        ...(params.options ?? {}),
        icon: params.icon ?? DEFAULT_ICON,
      }
    );

    if (!marker) {
      return {
        marker: L.marker([0, 0]),
        error: 'No se pudo crear el marker',
      };
    }

    // RAFA: EN CASO Q SE LENTEE MUCHO QUIZAS PUEDE SER POR ESTE CODIGO
    if (isFirefox() && params.animation) {
      // LA ANIMACION DE HOVER POR EL MOMENTO SOLO FUNCIONA EN FIREFOX
      addHoverScaleToMarker(marker);
    }

    return { marker, error: null };
  } catch (error) {
    return {
      marker: L.marker([0, 0]),
      error: 'Error desconocido al crear marker',
    };
  }
}

function managerValidations(params: ParamsCreateMarker): string | null {
  const { coordinates } = params;
  const { latitude, longitude } = coordinates;

  if (typeof latitude !== 'number' || typeof longitude !== 'number') {
    return 'Las coordenadas deben ser números válidos';
  }

  if (isNaN(latitude) || isNaN(longitude)) {
    return 'Las coordenadas no pueden ser NaN';
  }

  if (latitude < -90 || latitude > 90) {
    return 'La latitud debe estar entre -90 y 90';
  }

  if (longitude < -180 || longitude > 180) {
    return 'La longitud debe estar entre -180 y 180';
  }

  return null;
}
